exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".content {\n  max-width: 100%;\n  width: 100%;\n}\n\n.content img {\n  max-width: 100% !important;\n  height: auto !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!./app/routes/crm/style.css
// module id = 3577
// module chunks = 33